import React, { FC } from 'react';

import ErrorBoundary from 'buyside/components/presentation/ErrorBoundary/errorBoundary';
import EventPage from 'buyside/components/presentation/EventPage/eventPage';

document.getElementById('mainReactApp')?.setAttribute('data-no-padding', 'true');

const EventPageRoot: FC<{ contestId: string; isLoggedIn: string }> = ({
  contestId,
  isLoggedIn
}) => {
  return (
    <ErrorBoundary pageName="the event page">
      <EventPage contestId={contestId} isLoggedIn={isLoggedIn === 'true'} />
    </ErrorBoundary>
  );
};

export default EventPageRoot;
